
import TenantSettings from 'stores/tenant-settings'
import $chats from 'stores/chats'
import $tenants from 'stores/tenants'
import TenantFeed from './tenant-feed.vue'
import TenantAf   from './tenant-af.vue'
import TenantAi   from './tenant-ai.vue'
import TenantProducts from './tenant-products.vue'
import TenantPs from './tenant-ps.vue'
import TenantGeneral from './tenant-general.vue'
import TenantSkills from './tenant-skills.vue'

export default {
  components: {
    TenantFeed, TenantAf, TenantAi, TenantProducts, TenantPs, TenantGeneral, TenantSkills,
  },
  props: {
    tenant: {type: Object, required: true}
  },
  data() {
    return {
      tabs: [
        {value: 'general', title: 'General'},
        {value: 'feed', title: 'Feed'},
        {value: 'auto_follow', title: 'Auto Follow'},
        {value: 'ai', title: 'AI Settings'},
        {value: 'catalog', title: 'Catalog'},
        {value: 'preferred_sources', title: 'Preferred Sources'},
        {value: 'skills', title: 'Skills & Sources'},
      ],
      active: 'general',
      loading: true,
      saving: false,
      saved_at: undefined,
      store: undefined,
    }
  },
  async mounted() {
    this.loading = true
    this.store = new TenantSettings(this.tenant.id)
    await this.store.load({load_caps: true})
    this.loading = false
  },
  methods: {
    async onUpdate() {
      this.saving = true
      await this.store.save()
      await Promise.all([
        $chats.load(),
        $tenants.loadCaps(),
      ])
      this.saved_at = Date.now()
      this.saving = false
    }
  }
}
